<template>
  <v-select
    :items="options"
    item-value="id"
    item-text="value"
    v-model="valueComputed"
    :label="label"
    :rules="[requiredCheck()]"
    :disabled="disabled"
    :clearable="clearable ? clearable : false"
    :readonly="readonly ? readonly : false"
    :dense="dense ? dense : false"
    :hide-details="hideDetails != null ? hideDetails : false"
    outlined
  ></v-select>
</template>

<script>
import { required } from '@/lib/formValidations'

export default {
  props: [
    'value',
    'label',
    'isRequired',
    'disabled',
    'clearable',
    'readonly',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      options: [
        { id: 1, value: 'No Time Sheet' },
        { id: 2, value: 'Normal Time Sheet' },
        { id: 3, value: 'Clock In/Clock Out' }
      ]
    }
  },
  computed: {
    valueComputed: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('typeChange', newValue)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required(this.label ? this.label : 'This Field')
    }
  }
}
</script>
